// @see: https://lcab.talk-me.ru/online#online/api/javascript/api-js
(function (w) {
    let talkme_key = $('meta[name=talkme-key]').attr('content');

    if (typeof talkme_key !== "string") {
        return;
    }

    w.talkme = null;
    w.supportAPIMethod = 'talkme';
    w.talkmeIsInitialized = false;

    w.talkmeSetup = {
        language: $('html').attr('lang')
    };

    $.getScript('https://lcab.talk-me.ru/support/support.js?h=' + talkme_key, function () {
        window.talkmeLoader = setInterval(function () {
            if (window.talkmeIsInitialized && typeof window.talkme == "function") {

                window.talkme("setCallback", 'openSupport', function () {
                    $('.widget-support').fadeOut(200);
                });

                window.talkme("setCallback", 'closeSupport', function () {
                    $('.widget-support').fadeIn(200);
                });

                $('.support-chat').fadeIn(300).click(function () {
                    try {
                        window.talkme("openSupport");
                    } catch (e) {
                        console.error("Error support module:", e.message);
                    }
                });

                clearInterval(window.talkmeLoader);
            }
        }, 200);
    });
})(window);
